import React from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import SEO from "@/components/SEO";
import PageHero from "@/components/PageHero";
import Reveal from "@/components/Reveal";
import CTABand from "@/components/CTABand";
import { articlesOne } from "@/data/articles1";
import { articlesTwo } from "@/data/articles2";
import { articlesThree } from "@/data/articles3";

export const allArticles = [...articlesOne, ...articlesTwo, ...articlesThree];

const Insights = () => (
  <div data-testid="insights-page">
    <SEO
      title="ACRE Insights — UAE Property Investment Guides"
      description="Educational guides for overseas buyers: UAE vs UK, India and USA comparisons, off-plan buying, Golden Visa, branded residences, freehold ownership and rental yields."
      path="/insights"
      keywords="Dubai property investment for UK buyers, buying property in Dubai as a UK citizen, rental yield properties Dubai, Al Marjan Island property investment"
    />
    <PageHero
      eyebrow="ACRE Insights"
      title="Read the market before you enter it"
      intro="Educational guides for overseas buyers — written plainly, evidenced properly, and free of sales pressure."
      testid="insights-hero"
    />
    <section className="pb-24">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 grid sm:grid-cols-2 lg:grid-cols-3 gap-6" data-testid="insights-grid">
        {allArticles.map((a, i) => (
          <Reveal key={a.slug} delay={(i % 3) * 0.07}>
            <Link
              to={`/insights/${a.slug}`}
              data-testid={`article-card-${a.slug}`}
              className="card-hover group flex flex-col h-full bg-[#13151D] border border-[rgba(197,168,128,0.15)] rounded-2xl overflow-hidden"
            >
              <div className="relative h-52 overflow-hidden">
                <img src={a.image} alt={a.title} loading={i > 2 ? "lazy" : "eager"} className="card-img w-full h-full object-cover" />
                <div className="absolute inset-0 bg-gradient-to-t from-[#13151D] to-transparent" />
                <span className="absolute top-4 left-4 text-[10px] uppercase tracking-[0.18em] text-[#E6CA65] bg-[#0B0C10]/70 backdrop-blur px-3 py-1.5 rounded-full border border-[rgba(197,168,128,0.25)]">
                  {a.category}
                </span>
              </div>
              <div className="p-6 flex flex-col flex-1">
                <h2 className="font-display text-xl text-[#F4F3EF] leading-snug mb-3 group-hover:text-[#E6CA65] transition-colors duration-300">
                  {a.title}
                </h2>
                <p className="text-sm text-[#9DA3AE] font-light leading-relaxed flex-1">{a.excerpt}</p>
                <div className="flex items-center justify-between mt-5 pt-4 border-t border-[rgba(197,168,128,0.12)]">
                  <span className="text-[11px] text-[#6b7280]">{a.readTime}</span>
                  <span className="text-[#C5A880] group-hover:translate-x-1 group-hover:-translate-y-1 transition-transform duration-300">
                    <ArrowUpRight size={16} />
                  </span>
                </div>
              </div>
            </Link>
          </Reveal>
        ))}
      </div>
    </section>
    <CTABand testid="insights-cta" title="Prefer a conversation to a reading list?" />
  </div>
);

export default Insights;
